import React, { useEffect, useState } from "react";
import CurrencyConverter from "./CurrencyConverter";
import StepTab from "./StepTab";
import OrderSummary from "./OrderSummary";
import Popup from "./Popup";

const Card = ({
  data,
  type,
  quantities,
  handleQuantityChange,
  selectedProduct,
  setSelectedProduct,
  addonCart,
  setAddonCart,
  setQuantities,
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isItemAdded, setIsItemAdded] = useState(false);

  const handleCart = (data) => {
    setIsItemAdded(true);
    setAddonCart((prevCart) => {
      const quantity = quantities[data.id] || 1; // get quantity from quantities object

      // Create a new entry for the current item
      const newItem = {
        id: data.id,
        name: data.name,
        list_price: data.list_price,
        tax_price: data.tax_price,
        tax_string: data.tax_string,
        cgst: data.cgst,
        sgst: data.sgst,
        quantity: quantity,
        total: quantity * data.tax_price,
      };

      // Return new cart object with this item added/updated
      return {
        ...prevCart,
        [data.name]: newItem,
      };
    });
  };

  const handleRemoveItem = (data) => {
    setIsItemAdded(false);
    setAddonCart((prev) => {
      const updatedCart = Object.fromEntries(
        Object.entries(prev).filter(([key, value]) => value.id !== data.id),
      );

      return updatedCart;
    });
    setQuantities((prev) => ({
      ...prev,
      [data.id]: 1,
    }));
  };

  return (
    <div className="flex flex-col xl:flex-row items-start gap-[2vw] py-[3vw] md:py-[1.5vw] mb-[3vw] md:mb-[1vw] border-b-[0.01vw] border-[#002C62]">
      <img
        src={`data:image/png;base64,${
          type === "service" ? data?.product?.image_1920 : data?.image_1920
        }`}
        alt={type === "service" ? data?.product?.name : data?.name}
        className="w-[35vw] md:w-[20vw] xl:w-[10vw] h-auto rounded-md object-cover border border-gray-300"
      />
      <div className="flex-1 font-redhatRegular">
        <h3 className="text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] font-redhatMedium">
          {type === "service"
            ? data?.product?.name
            : `${data?.name} (₹ ${data?.tax_price} Per Unit)`}
        </h3>
        <p className="text-[3.5vw] md:text-[2vw] xl:text-[1vw] font-redhatRegular text-primary mt-[0.5vw]">
          {type === "service" ? data?.product?.categ_id[1] : data?.categ_id[1]}
        </p>
        {type === "service" && (
          <p className="text-[3.5vw] md:text-[2vw] xl:text-[1vw] mt-[0.5vw] text-[#002C5F] font-redhatMedium">
            {`₹ ${(data?.product?.tax_price).toFixed(0, 2)} for 1 adult`}
          </p>
        )}
        {type === "service" ? (
          <div className="flex gap-[1vw] mt-[1vw]">
            <button
              onClick={() => setShowPopup(true)}
              className="border border-[#002C5F] text-[#002C5F] px-[2.5vw] md:px-[1.8vw] xl:px-[1.2vw] py-[0.8vw] md:py-[0.5vw] xl:py-[0.4vw] rounded-lg text-[3.5vw] md:text-[2vw] xl:text-[0.9vw] font-redhatMedium hover:bg-[#002C5F] hover:text-white transition"
            >
              Details
            </button>
            <button
              onClick={() => setSelectedProduct(data)}
              className={`px-[2.5vw] md:px-[1.8vw] xl:px-[1.2vw] py-[0.8vw] md:py-[0.5vw] xl:py-[0.4vw] rounded-lg text-[3.5vw] md:text-[2vw] xl:text-[0.9vw] font-redhatMedium ${
                selectedProduct && selectedProduct.id === data.id
                  ? "bg-[#002C5F] text-white"
                  : "border border-[#002C5F] text-[#002C5F] hover:bg-[#002C5F] hover:text-white transition"
              }`}
            >
              {selectedProduct?.product &&
              selectedProduct.product.id === data.product.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
        ) : (
          <div>
            <div className="flex items-center gap-[1vw] mt-[1vw] mb-[0.5vw]">
              <p className="text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] font-redhatMedium">
                Quantity
              </p>
              <div className="flex items-center border border-gray-400 rounded-md">
                <button
                  disabled={isItemAdded}
                  onClick={() => handleQuantityChange(data.id, "decrease")}
                  className="px-[2vw] xl:px-[1vw] py-[0.5vw] xl:py-[0.2vw]"
                >
                  -
                </button>
                <span className="px-[1vw]">{quantities[data?.id] || 1}</span>
                <button
                  disabled={isItemAdded}
                  onClick={() => handleQuantityChange(data.id, "increase")}
                  className="px-[2vw] xl:px-[1vw] py-[0.5vw] xl:py-[0.2vw]"
                >
                  +
                </button>
              </div>
            </div>

            <div className="flex gap-[2vw] xl:gap-[1vw] mt-[2vw] xl:mt-[1vw]">
              <button
                onClick={() => setShowPopup(true)}
                className="border border-[#002C5F] text-[#002C5F] px-[2.5vw] md:px-[1.8vw] xl:px-[1.2vw] py-[0.8vw] md:py-[0.5vw] xl:py-[0.4vw] rounded-lg text-[3.5vw] md:text-[2vw] xl:text-[0.9vw] font-redhatMedium hover:bg-[#002C5F] hover:text-white transition"
              >
                Details
              </button>
              <button
                onClick={() => handleCart(data)}
                className="border border-[#002C5F] px-[2.5vw] md:px-[1.8vw] xl:px-[1.2vw] py-[0.8vw] md:py-[0.5vw] xl:py-[0.4vw] rounded-lg text-[3.5vw] md:text-[2vw] xl:text-[0.9vw] font-redhatMedium  bg-[#002C5F] text-white transition"
              >
                {isItemAdded ? "Added" : "Add"}
              </button>
              {isItemAdded && (
                <button
                  onClick={() => handleRemoveItem(data)}
                  className="border border-[#002C5F] px-[2.5vw] md:px-[1.8vw] xl:px-[1.2vw] py-[0.8vw] md:py-[0.5vw] xl:py-[0.4vw] rounded-lg text-[3.5vw] md:text-[2vw] xl:text-[0.9vw] font-redhatMedium  bg-[#002C5F] text-white transition"
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      {showPopup ? (
        <Popup
          title={data?.product?.name || data?.name}
          text={data?.product?.description || data?.description}
          setShowPopup={setShowPopup}
        />
      ) : null}
    </div>
  );
};

const GreetserviceStep2 = ({
  data,
  activeTab,
  setActiveTab,
  handleNext,
  tabClass,
}) => {
  const [quantities, setQuantities] = useState({});
  const [selectedProduct, setSelectedProduct] = useState();
  const [addonCart, setAddonCart] = useState({});

  let bookingData;
  if (typeof window !== "undefined" && window.sessionStorage) {
    bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
  }

  const handleQuantityChange = (id, type) => {
    setQuantities((prev) => {
      const current = prev[id] || 1;

      if (type === "decrease") {
        return { ...prev, [id]: Math.max(current - 1, 1) };
      }
      // increase case
      if (current >= 3) {
        alert("Maximum quantity allowed is 3");
        return prev; // do not update state
      }

      return { ...prev, [id]: current + 1 };
    });
  };

  const childPackage = selectedProduct?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "child",
  );
  const adultPackage = selectedProduct?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "adult",
  );

  const packagePrice =
    selectedProduct?.product?.list_price * parseInt(bookingData?.adults);
  const childPackagePrice =
    bookingData?.child > 0 &&
    Array.isArray(selectedProduct?.productVariant) &&
    childPackage?.length > 0
      ? parseFloat(
          (childPackage?.[0]?.lst_price * parseInt(bookingData.child)).toFixed(
            2,
          ),
        )
      : null;

  const addonTotal =
    addonCart &&
    Object.values(addonCart).reduce((acc, item) => {
      return acc + item.list_price * item.quantity;
    }, 0);

  const sgst = parseFloat(
    Array.isArray(selectedProduct?.productVariant) &&
      (adultPackage?.[0]?.sgst).toFixed(2) * parseInt(bookingData?.adults),
  );
  const cgst = parseFloat(
    Array.isArray(selectedProduct?.productVariant) &&
      (adultPackage?.[0]?.cgst).toFixed(2) * parseInt(bookingData?.adults),
  );

  const childCGST = parseFloat(
    Array.isArray(selectedProduct?.productVariant) &&
      (childPackage?.[0]?.cgst).toFixed(2) * parseInt(bookingData?.child),
  );

  const childSGST = parseFloat(
    Array.isArray(selectedProduct?.productVariant) &&
      (childPackage?.[0]?.sgst).toFixed(2) * parseInt(bookingData?.child),
  );

  const addonCGST = parseFloat(
    addonCart &&
      Object.values(addonCart)
        .reduce((acc, item) => {
          return acc + item.cgst * item.quantity;
        }, 0)
        .toFixed(2),
  );

  const addonSGST = parseFloat(
    addonCart &&
      Object.values(addonCart)
        .reduce((acc, item) => {
          return acc + item.sgst * item.quantity;
        }, 0)
        .toFixed(2),
  );

  useEffect(() => {
    const result =
      data &&
      data[0]?.addon.reduce((acc, el) => {
        acc[el.id] = 1;
        return acc;
      }, {});
    setQuantities(result);
  }, []);

  return (
    <div>
      <CurrencyConverter
        totalAmount={Math.round(
          packagePrice +
            childPackagePrice +
            addonTotal +
            cgst +
            sgst +
            addonCGST +
            addonSGST +
            childCGST +
            childSGST,
        )}
      />
      <div className="w-full px-[7vw] mt-[2vw] font-redhatRegular text-[#002C5F]">
        <StepTab
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabClass={tabClass}
        />
      </div>

      <div className="w-full px-[7vw] mt-[2vw] font-redhatRegular text-[#002C5F]">
        <div className="grid grid-cols-1 xl:grid-cols-[1fr_auto] gap-[4vw] xl:gap-[2vw]">
          {/* Left Section (Services + Add-ons) */}
          <div className="order-1 xl:order-1">
            {/* Services */}
            <div>
              {data &&
                data?.map((s) => (
                  <Card
                    key={s?.product?.id}
                    data={s}
                    type="service"
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelectedProduct}
                  />
                ))}
            </div>

            {/* Add-Ons */}
            <div className="mt-[4vw]">
              <h2 className="text-[4vw] md:text-[3vw] xl:text-[1.5vw] font-redhatBold mb-[2vw]">
                Add-Ons
              </h2>
              {data &&
                data[0]?.addon.length > 0 &&
                data[0]?.addon?.map((item) => (
                  <Card
                    key={item.id}
                    data={item}
                    type="addon"
                    quantities={quantities}
                    handleQuantityChange={handleQuantityChange}
                    addonCart={addonCart}
                    setAddonCart={setAddonCart}
                    setQuantities={setQuantities}
                  />
                ))}
            </div>
          </div>

          {/* Right Section (Order Summary) */}
          {selectedProduct && (
            <div className="order-3 xl:order-2 xl:justify-self-end">
              <OrderSummary
                bookingData={bookingData}
                addonCart={addonCart}
                data={selectedProduct}
                handleNext={handleNext}
                nextStep="Login"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GreetserviceStep2;
